var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qty"},[_c('span',{staticClass:"minus bg-red",on:{"click":_vm.minus}},[_vm._v("-")]),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v("\n        "+_vm._s(_vm.countFormatted)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"plus bg-red",on:{"click":_vm.plus}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }